module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (options.title) { 
__p+='\n<div class="modal-header">\n    <h4 class="modal-title">\n        '+
((__t=( options.title ))==null?'':_.escape(__t))+
'\n    </h4>\n</div>\n';
 } 
__p+='\n<div class="modal-body tl-content-view-region">\n    '+
((__t=( options.confirmText ))==null?'':__t)+
'\n</div>\n<div class="modal-footer">\n    ';
 if (options.showCancelButton) { 
__p+='\n        <button type="button" class="tl-cancel-btn btn btn-default">'+
((__t=( options.cancelButtonLabel ))==null?'':_.escape(__t))+
'</button>\n    ';
 } 
__p+='\n    <button type="button" class="tl-primary-confirm-btn btn btn-primary">'+
((__t=( options.confirmButtonLabel ))==null?'':_.escape(__t))+
'</button>\n    ';
 if (options.showSecondaryConfirmButton) { 
__p+='\n    <button type="button" class="tl-secondary-confirm-btn btn btn-secondary">'+
((__t=( options.secondaryConfirmButtonLabel ))==null?'':_.escape(__t))+
'</button>\n    ';
 } 
__p+='\n</div>';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/treeline-shared-components/confirm-dialog/confirm-dialog.tpl
 ** module id = 908
 ** module chunks = 1 2 110
 **/